declare global {
  const MONOCLE_CONTEXT: string;
}

/**
 * Initialize all Ari images
 */
export const initAriImages = (ariOptions: { imgProviderUrl: string }, ariCallback: (options?: object) => void) => {

  const callAri = () => ariCallback(ariOptions);

  const initAllAri = () => {
    if (typeof MONOCLE_CONTEXT !== 'undefined') {
      ariOptions.imgProviderUrl = 'https://picsum.photos/{originalwidth}/{originalheight}';
    }

    document.querySelectorAll('[data-ari-params]').forEach(imageHolder => {
      if (imageHolder.closest('[data-nezzo-ari-ignore-children]')) {
        return;
      }

      callAri();
    });
  };


  ['load', 'scroll'].forEach((eventType) => {
    window.addEventListener(eventType, callAri);
  });

  let ariResizeTimer: number;
  window.addEventListener('resize', () => {
    clearTimeout(ariResizeTimer);
    ariResizeTimer = window.setTimeout(callAri, 250);
  });

  // Needed for loading images after adding in the inspector
  if (document.body.classList.contains('neos-backend')) {
    document.addEventListener('Neos.NodeSelected', initAllAri, false);
  }
};
